import { render, staticRenderFns } from "./BiometricPinMapping.vue?vue&type=template&id=1279123a&scoped=true"
import script from "./BiometricPinMapping.vue?vue&type=script&lang=js"
export * from "./BiometricPinMapping.vue?vue&type=script&lang=js"
import style0 from "./BiometricPinMapping.vue?vue&type=style&index=0&id=1279123a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1279123a",
  null
  
)

export default component.exports